<template>
	<div class="activity-list-item" @click="goToActivityDetail(itemInfo.aid)">
		<div class="item-img">
			<img :src="itemInfo.attach"/>
		</div>
		<div class="item-text">
			<p class="item-title">{{itemInfo.title}}</p>
			<p class="item-time">时间：{{itemInfo.start_time | toDateTime | convertTime("YYYY-MM-DD")}}</p>
			<p class="item-address">地点：{{itemInfo.detailed_address	}}</p>
		</div>
		<div class="item-status">
			<span v-if="itemInfo.status==0">审核中</span>
					<span v-if="itemInfo.status==1">正常使用</span>
					<span v-if="itemInfo.status==2">已删除</span>
					<span v-if="itemInfo.status==3">取消活动</span>
					<span v-if="itemInfo.status==4">已结束</span>
		</div>
	</div>
</template>

<script>
	export default{
		name:"my-activity-list-item",
		props:["itemInfo"],
		data(){
			return{
				
			}
		},
		methods:{
			goToActivityDetail(id){
				this.$router.push({
					name:"activity-detail",
					query:{
						id:id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.activity-list-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 1rem;
		margin: 1rem 0;
		position: relative;
	}
	.activity-list-item .item-img img{
		width: 6.5rem;
		display: block;
		border-radius: 5px;
	}
	.activity-list-item .item-text{
		flex: 1;
		padding: 0 0.5rem;
		padding-right: 0;
	}
	.activity-list-item .item-title{
		font-weight: bold;
		font-size: 1rem;
		line-height: 1.5rem;
		margin-bottom: 0.5rem;
	}
	.activity-list-item .item-time,.activity-list-item .item-address{
		font-size: 0.8rem;
		line-height: 1.5rem;
		color: #9e9e9e;
	}
	.activity-list-item .item-status{
		font-size: 0.8rem;
	    color:#ff8e90;
	    display: inline-block;
	    padding: 0.2rem 0.5rem;
	    border-radius: 3px;
	    align-self: flex-start
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/MyActivityListItem.vue